<i18n lang="yaml">
en:
  title: 'Error {0} has occurred'
  text1: 'You can go to the'
  text2: 'main page'
ru:
  title: 'Произошла ошибка {0}'
  text1: 'Вы можете перейти на'
  text2: 'главную страницу'
</i18n>

<template>
  <not-found v-if="is404"></not-found>
  <section
    v-else
    class="s-section"
  >
    <div class="container">
      <h1 v-html="$t('title', [error.statusCode])"></h1>
      {{ $t('text1') }}
      <nuxt-link :to="localePath('/')">
        {{ $t('text2') }}
      </nuxt-link>.
    </div>
  </section>
</template>

<script>
import NotFound from '~/components/error/NotFound'

export default {
  name: 'ErrorPage',
  components: {
    NotFound
  },
  props: {
    error: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    is404() {
      return this.error.statusCode === 404
    }
  },
  beforeMount() {
    this.$store.dispatch('modules/account/fetchAccount')
    this.$store.dispatch('modules/status-panel/fetchStatus')
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      title: this.$i18n.locale === 'ru'
        ? `Ошибка ${this.error.statusCode}`
        : `Error ${this.error.statusCode}`,
      meta: [
        {hid: 'robots', name: 'robots', content: 'noindex'}
      ]
    }
  }
}
</script>